(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bobbin-signup-modal"] && !Shopify.designMode) return;
  try {
    
  const STORE_KEY = 'bobbin:signup';

  class OddsSignup extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.so-signup__card');
      this.field = this.querySelector('[data-field]');
      this.remember = parseInt(this.dataset.remember, 10) || 30;

      this.querySelectorAll('[data-close]').forEach((el) =>
        el.addEventListener('click', () => this.close(true))
      );

      // Any link to #signup opens the card instead of jumping the page.
      this.onAnchor = (event) => {
        const trigger = event.target.closest('a[href$="#signup"], [data-so-signup]');
        if (!trigger) return;
        event.preventDefault();
        this.open();
      };
      document.addEventListener('click', this.onAnchor);

      this.onKey = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close(false);
      };
      document.addEventListener('keydown', this.onKey);

      // A successful post reopens the card so the confirmation is actually seen.
      if (this.dataset.posted === 'true') {
        this.open();
        return;
      }

      if (this.dataset.auto === 'true' && !this.suppressed()) {
        const delay = (parseFloat(this.dataset.delay) || 12) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('click', this.onAnchor);
      document.removeEventListener('keydown', this.onKey);
    }

    // Storage throws outright in some privacy modes, so never let it break the page.
    suppressed() {
      try {
        const until = parseInt(localStorage.getItem(STORE_KEY), 10);
        return Number.isFinite(until) && Date.now() < until;
      } catch (error) {
        return false;
      }
    }

    remember_dismissal() {
      try {
        localStorage.setItem(STORE_KEY, String(Date.now() + this.remember * 86400000));
      } catch (error) {
        /* private mode - fall back to per-session only */
      }
    }

    open() {
      clearTimeout(this.timer);
      this.opener = document.activeElement;
      this.hidden = false;
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        if (this.field) this.field.focus({ preventScroll: true });
      });
    }

    close(persist) {
      this.classList.remove('is-open');
      if (persist) this.remember_dismissal();
      const done = () => {
        this.hidden = true;
      };
      setTimeout(done, 280);
      if (this.opener && this.opener.focus) this.opener.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('so-signup')) {
    customElements.define('so-signup', OddsSignup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bobbin-video-reviews"] && !Shopify.designMode) return;
  try {
    
  // One play event per video per page view. Shopify and app pixels own commerce
  // events; this is engagement only and must not duplicate them.
  document.addEventListener(
    'play',
    (event) => {
      const el = event.target;
      if (!(el instanceof HTMLVideoElement) || !el.hasAttribute('data-so-video')) return;
      if (el.dataset.played === 'true') return;
      el.dataset.played = 'true';
      try {
        window.Shopify?.analytics?.publish?.('bobbin_video_review_play', {});
      } catch (error) {
        /* analytics must never break playback */
      }
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class OddsAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.so-ann__item')];
      if (this.items.length < 2) return;

      this.index = 0;
      this.toggle = this.querySelector('.so-ann__toggle');
      this.hold = (parseFloat(this.dataset.speed) || 5) * 1000;

      // Honour reduced motion: show the first message and never auto-advance,
      // but leave the control so it can still be started by hand.
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.held = this.reduced;

      if (this.toggle) {
        this.toggle.addEventListener('click', () => {
          this.held = !this.held;
          this.sync();
        });
      }

      // Pointing at the bar or tabbing into it holds the rotation, so a message
      // can be read to the end without hunting for a control first.
      this.addEventListener('pointerenter', () => { this.hovered = true; this.sync(); });
      this.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); });
      this.addEventListener('focusin', () => { this.focused = true; this.sync(); });
      this.addEventListener('focusout', () => { this.focused = false; this.sync(); });

      this.sync();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      const next = (this.index + 1) % this.items.length;
      this.items[this.index].classList.remove('is-active');
      this.items[this.index].setAttribute('aria-hidden', 'true');
      this.items[next].classList.add('is-active');
      this.items[next].removeAttribute('aria-hidden');
      this.index = next;
    }

    // The button reports the visitor's own choice, not a hover, so tabbing to it
    // never finds it claiming to be paused just because the pointer passed by.
    sync() {
      this.held || this.hovered || this.focused ? this.pause() : this.play();

      if (this.toggle) {
        this.toggle.setAttribute('aria-pressed', this.held ? 'true' : 'false');
        this.toggle.setAttribute('aria-label', this.held ? 'Play announcements' : 'Pause announcements');
      }
    }

    play() {
      this.paused = false;
      clearInterval(this.timer);
      this.timer = setInterval(() => this.advance(), this.hold);
    }

    pause() {
      this.paused = true;
      clearInterval(this.timer);
    }
  }

  if (!customElements.get('so-announcement')) {
    customElements.define('so-announcement', OddsAnnouncement);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
